// src/components/sections/TechnologiesSection.js
import React from 'react';

import html5 from '../../Assets/Images/html5.png';
import css3 from '../../Assets/Images/css3.png';
import javascript from '../../Assets/Images/javascript.png';
import react from '../../Assets/Images/react.png';
import nodejs from '../../Assets/Images/nodejs.png';
import python from '../../Assets/Images/python.png';
import canva from '../../Assets/Images/canva.jpg';
import flutter from '../../Assets/Images/flutter.jpg';
import aws from '../../Assets/Images/aws.jpg';
import mongodb from '../../Assets/Images/mongodb.png';

const techs = [html5, css3, javascript, react, nodejs, python, canva, flutter, aws, mongodb];
const techsReverse = [...techs].reverse();

const TechnologiesSection = () => {
  return (
    <div className="bg-transparent text-white py-16 px-6 h-[600px] overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 items-start h-full">
        {/* Left: Text Content */}
        <div className="col-span-1 md:col-span-8 space-y-4 h-full flex flex-col justify-center">
          <h2 className="text-3xl md:text-4xl font-bold">Technologies We Use</h2>
          <p className="text-base md:text-lg font-normal text-justify leading-relaxed">
            Welcome to our Technologies section — where innovation meets excellence.
            At the heart of everything we do is a deep commitment to leveraging the latest tools and frameworks to build powerful, scalable, and user-centric digital solutions.
            From robust backend systems to modern, responsive frontend interfaces, our technology stack is designed to meet the evolving needs of today's digital world.
            With a forward-thinking approach and industry-aligned strategies, we empower teams with the knowledge and tools to stay ahead of the curve.
            Our passion for technology fuels continuous innovation, driving progress and delivering real value in every project we undertake.
          </p>
        </div>

        {/* Right: Animated Icons (hidden on small screens) */}
        <div className="hidden  md:grid md:col-span-4 grid grid-cols-2 gap-4 relative h-full overflow-hidden">
          {/* Column 1: Scroll Down */}
          <div className="relative overflow-hidden h-full">
            <div className="animate-scroll-down flex flex-col gap-6">
              {[...techs, ...techs].map((tech, i) => (
                <div key={`down-${i}`} className="w-28 h-28 bg-white rounded-full flex items-center justify-center shadow-md">
                  <img src={tech} alt="tech-icon" className="w-20 h-20 object-contain" />
                </div>
              ))}
            </div>
          </div>

          {/* Column 2: Scroll Up */}
          <div className="relative overflow-hidden h-full">
            <div className="animate-scroll-up flex flex-col gap-6">
              {[...techsReverse, ...techsReverse].map((tech, i) => (
                <div key={`up-${i}`} className="w-28 h-28 bg-white rounded-full flex items-center justify-center shadow-md">
                  <img src={tech} alt="tech-icon" className="w-20 h-20 object-contain" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologiesSection;